<template>
  <div class="m-card-primary m-the-modal-content">
    <header class="m-the-modal-header">
      <h5>Invitación</h5>
      <AtomButtonTheModalCloseIcon/>
    </header>
    <section class="m-the-modal-section">
      <p>
        Invitación enviada el día {{ $moment($modal.element.fecha_creacion).format('D MMMM YYYY HH:mm') }} a <span class="font-weight-bold text-color-success">{{ $modal.element.email }}</span>
        para participar como <span class="font-weight-bold">{{ $filters.getActorValue($modal.element.actor_tipo, 'name') }}</span>
        <span v-if="$modal.element.proyecto_nombre !== undefined">
          en el proyecto <span class="font-weight-bold">{{ $modal.element.proyecto_nombre }}</span>
        </span>.
      </p>

      <p>
        <a
          class="text-color-academy-primary"
          :href="`${this.$utils.getMarketPlaceDomain().replace('/academia', '')}/aceptar-invitacion/${this.$modal.element.invitacion}`"
          target="_blank"
        >
          {{ `${this.$utils.getMarketPlaceDomain().replace('/academia', '')}/aceptar-invitacion/${this.$modal.element.invitacion}` }}
        </a>
      </p>

      <p class="font-size-small">Invitación creada por {{ $modal.element.creador_nombre }} - {{ $modal.element.creador_actor_tipo }} - {{ $modal.element.creador_email }}.</p>
    </section>
    <footer class="m-the-modal-footer">
      <AtomButtonTheModalCancelAction cancel-text="Salir"/>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetInvitationsModalData'
}
</script>
